import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { useNewClientContext } from 'Context/NewClientContext';
import { DrawerClientNavCPC } from './DrawerClientNavCPC';
import { DrawerClientNavFoundationalOnly } from './DrawerClientNavFoundationalOnly';

export const DrawerClientNavPicker = (props) => {
  const { clientResource } = useNewClientContext();
  const Component = pick(clientResource, {
    [fr.relationships.foundationalOnly.name]: DrawerClientNavFoundationalOnly,
  }, DrawerClientNavCPC);
  return <Component {...props} />;
};
